import React from "react";
import './css/Canvas.css';
import { connect } from "react-redux";
import { useEffect } from 'react';
import { deleteItems, select, setZoomLevel, toggleAxisHandle, updateItem } from "./canvasSlice";
import store from "./store";
import * as PolylineTool from "./tools/PolylineTool";
import * as d3 from 'd3';
import { activateTool } from "./toolSlice";


const mapStateToProps = state => ({
    selected: state.canvas.selected,
    itemUpdated: state.canvas.itemUpdated,
    scaleUpdated: state.canvas.scaleUpdated,
    dataItemJoined: state.canvas.dataItemJoined,
    itemsDeleted: state.canvas.itemsDeleted,
    zoomLevel: state.canvas.zoomLevel,
    panDelta: state.canvas.panDelta
});

function Canvas(props) {

    useEffect(() => {
        props.renderer.render(props.scene);
    }, [props.scene, props.renderer, props.itemUpdated, props.scaleUpdated, props.dataItemJoined, props.itemsDeleted])

    useEffect(() => {
        if (!props.zoomLevel) return;
        let svgs = ["#canvas", "#evtLayer"];
        for (let s of svgs) {
            let svg = d3.select(s), vb = svg.attr("viewBox"), 
                bbox = svg.node().getBoundingClientRect(), wd = bbox.width, ht = bbox.height;
            let left = vb? parseInt(vb.split(" ")[0]) : 0, top = vb? parseInt(vb.split(" ")[1]) : 0;
            svg.attr("viewBox", [left, top, left + wd*100/props.zoomLevel, top + ht*100/props.zoomLevel].join(" "));
        }
    }, [props.zoomLevel])

    const resetViewBox = () => {
        let svgs = ["#canvas", "#evtLayer"];
        for (let s of svgs) {
            let svg = d3.select(s),
                bbox = svg.node().getBoundingClientRect(), wd = bbox.width, ht = bbox.height;
            svg.attr("viewBox", [0, 0, wd, ht].join(" "));
        }
    }

    useEffect(() => {
        if (!props.panDelta) return;
        let svgs = ["#canvas", "#evtLayer"];
        for (let s of svgs) {
            let svg = d3.select(s), vb = svg.attr("viewBox"),
                bbox = svg.node().getBoundingClientRect(), wd = bbox.width, ht = bbox.height;
            let vbArr = vb ? vb.split(" ").map(d => parseInt(d)) : [0, 0, wd, ht];
            svg.attr("viewBox", [vbArr[0] + props.panDelta.x, vbArr[1] + props.panDelta.y, vbArr[2], vbArr[3]].join(" "));
        }
    }, [props.panDelta])

    useEffect(() => {

        const translateByKey = (x, y) => {
            let s = store.getState().canvas.selected;
            if (s && s.length > 0) {
                let item = props.scene.getItem(s[0]);
                if (item && item.type === "axis") {
                    store.dispatch(toggleAxisHandle({visible: false}));
                    if (item.channel === "x" || item.channel === "width") {
                        item.pathY = item.pathY + y;
                    } else if (item.channel === "y" || item.channel === "height") {
                        item.pathX = item.pathX + x;
                    }
                    store.dispatch(updateItem({id: item.id, type: item.type, properties: {pathPosition: item.pathPosition}}));
                } else if (item) {
                    props.scene.translate(item, x, y);
                    store.dispatch(updateItem({id: item.id, type: item.type, properties: {x: item.x, y: item.y}}));
                }
            }
            let ds = store.getState().canvas.directSelected;
            if (ds) {
                let itm = props.scene.getItem(ds);
                if (itm.parent.type === "path") {
                    itm._doTranslate(x, y);
                    store.dispatch(updateItem({id: itm.parent.id, type: itm.parent.type, properties: {x: itm.parent.x, y: itm.parent.y}}));
                }
            }
        }

        document.addEventListener('keydown', (e) => {
            // e.preventDefault();
            // e.stopPropagation();
            switch(e.key) {
                case "Delete": {
                    let s = store.getState().canvas.selected;
                    if (s && s.length > 0) {
                        for (let i = s.length - 1; i >= 0; i--) {
                            let item = props.scene.getItem(s[i]);
                            if (item && item.parent === props.scene) {
                                store.dispatch(select([]));
                                props.scene.removeItem(item);
                                store.dispatch(deleteItems([item].map(d => d.id)));
                            }
                        }
                    }
                    break;
                }
                case "ArrowLeft": {
                    translateByKey(-5, 0);
                    break;
                }
                case "ArrowRight": {
                    translateByKey(5, 0);
                    break;
                }
                case "ArrowUp": {
                    translateByKey(0, -5);
                    break;
                }
                case "ArrowDown": {
                    translateByKey(0, 5);
                    break;
                }
                case "Escape": {
                    if (store.getState().tool.activeTool === "Pen") {
                        PolylineTool.finish(props.scene, props.datasets, props.renderer, props.undoStack);
                        store.dispatch(activateTool("Select"));
                    }
                    break;
                }
                // += - zoom in
				case "+":
                case "=":
                    if(e.ctrlKey || e.metaKey) {
                        e.preventDefault();
                        let z = Math.min(400, store.getState().canvas.zoomLevel + 10);
                        store.dispatch(setZoomLevel(z));
                    }
                    break;
                // - - zoom out
                case "-":
                    if(e.ctrlKey || e.metaKey) {
                        e.preventDefault();
                        let z = Math.max(20, store.getState().canvas.zoomLevel - 10);
                        store.dispatch(setZoomLevel(z));
                    }
                    break;
                case "0":
                    if(e.ctrlKey || e.metaKey) {
                        e.preventDefault();
                        resetViewBox();
                    }
                    break;
                default:
                    break;
            }
        });
    },[props.scene, props.datasets, props.renderer, props.undoStack])

    switch(props.type) {
        case "canvas":
            return (
                <canvas className="canvas" id="canvas"></canvas>
            );
        default:
        case "svg":
            return (
                <svg className="canvas" id="canvas"></svg>
            );
    }
}

export default connect(mapStateToProps)(Canvas);;